module.exports = __webpack_public_path__ + "img/1485660357.ef026ca9.jpg";